import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, Box, Typography } from '@mui/material';
import React from 'react';

const ContradictionAlert: React.FC<{ reason: string }> = ({ reason }) => (
  <Alert
    severity="warning"
    icon={false}
    sx={{ textAlign: 'center', py: 1, '& .MuiAlert-message': { width: '100%', py: 0 } }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mb: 0.25,
      }}
    >
      <WarningAmberIcon sx={{ color: 'warning.main' }} />
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Contradiction Detected
      </Typography>
    </Box>
    <Typography variant="body2">{reason}</Typography>
  </Alert>
);

export default ContradictionAlert;
